import * as RadixTooltip from "@radix-ui/react-tooltip";

type Props = RadixTooltip.TooltipTriggerProps;

const Trigger = (props: Props) => {
    const { children, asChild, ...rest } = props;

    return (
        <RadixTooltip.Trigger asChild {...rest}>
            {asChild ? children : <span>{children}</span>}
        </RadixTooltip.Trigger>
    );
};

Trigger.displayName = "Tooltip.Trigger";

export { Trigger };
export type { Props as TriggerProps };
